import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

// Components
import AppointmentFlowHeader from './AppointmentFlowHeader';

// Actions
import { goTo } from 'store/reducers/navigation/actions';
import { gtmUserEventShoppingCart } from 'store/reducers/gtm/actions';

// Selectors
import {
  getTotalPrice,
  getServicesCount,
  getServices,
  getDeclinedServices
} from 'store/reducers/appointment/selectors';
import {
  getPriceVisibility,
  getFlexPayConfiguration
} from 'store/reducers/dealerSettings/selectors';
import { isLoggedIn } from 'store/reducers/user/selectors';
import { getProperty } from 'store/reducers/user/personInfo/selectors';
import { hasPromotion } from 'store/reducers/promotions/selectors';
import { getAppFlow } from 'store/reducers/userInteractions/selectors';

const mapStateToProps = state => {
  return {
    services: getServices(state).concat(getDeclinedServices(state)),
    servicesCount: getServicesCount(state),
    totalPrice: getTotalPrice(state),
    showPrice: getPriceVisibility(state)(),
    isLoggedIn: isLoggedIn(state),
    firstName: getProperty(state, 'firstName'),
    lastName: getProperty(state, 'lastName'),
    hasPromotion: hasPromotion(state),
    isFlexPayEnabled: getFlexPayConfiguration(state),
    appFlow: getAppFlow(state)
  };
};

const mapDispatchToProps = dispatch => {
  return bindActionCreators({ goTo, gtmUserEventShoppingCart }, dispatch);
};

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true }
  )
)(AppointmentFlowHeader);



// WEBPACK FOOTER //
// ./src/components/molecules/AppointmentFlowHeader/AppointmentFlowHeaderContainer.js